export const api = {
  async logout(): Promise<void> {
    return new Promise((resolve) => {
      resolve();
    });
  },
};

export default api;
